// layouts/AdminLayout.jsx

import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import RouteLoader from "./components/RouteLoader";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";

export default function AdminLayout() {

  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768
  );

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    window.innerWidth >= 768
  );


  /* =========================================
     ROUTE LOADER
  ========================================= */

  useEffect(() => {

    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 300);

    return () => clearTimeout(timer);

  }, [location.pathname]);


  /* =========================================
     RESPONSIVE SIDEBAR
  ========================================= */

  useEffect(() => {

    const handleResize = () => {

      const mobile = window.innerWidth < 768;

      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }

    };


    window.addEventListener(
      "resize",
      handleResize
    );


    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };

  }, []);


  /* =========================================
     TOGGLE SIDEBAR
  ========================================= */

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };


  /* =========================================
     CONTENT POSITION
  ========================================= */

  const getContentStyle = () => {

    if (isMobile) {

      return {
        marginLeft: "0px",
        paddingTop: "100px",
      };

    }


    if (isSidebarOpen) {

      return {
        marginLeft: "250px",
        paddingTop: "58px",
      };

    }


    return {
      marginLeft: "73px",
      paddingTop: "58px",
    };

  };


  return (

    <div className="admin-layout">

      {/* ===============================
          SIDEBAR
      ================================ */}

      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />


      {/* ===============================
          HEADER
      ================================ */}

      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />


      {/* ===============================
          PAGE CONTENT
      ================================ */}

      <main
        className=""
        style={getContentStyle()}
      >

        {loading && <RouteLoader />}

        <Outlet />

      </main>


      {/* ===============================
          GLOBAL CSS
      ================================ */}

      <style>{`

        * {
          box-sizing: border-box;
        }


        .admin-layout {
          width: 100%;
          min-height: 100vh;
          background: #f4f5f8;
        }


        .admin-content-wrapper {

          min-height: 100vh;

          width: auto;

          background: #f4f5f8;

          transition:
            margin-left 0.25s ease,
            padding-top 0.25s ease;

          overflow-x: hidden;

        }


        /* =====================================
           DESKTOP
        ====================================== */

        @media (min-width: 769px) {

          .admin-content-wrapper {

            padding-left: 0;
            padding-right: 0;
            padding-bottom: 20px;

          }

        }


        /* =====================================
           TABLET
        ====================================== */

        @media (max-width: 992px) {

          .admin-content-wrapper {

            margin-left: 0 !important;

          }

        }


        /* =====================================
           MOBILE
        ====================================== */

        @media (max-width: 768px) {

          .admin-content-wrapper {

            width: 100%;

            min-height: 100vh;

            padding-left: 0 !important;
            padding-right: 0 !important;

            padding-bottom: 15px;

          }

        }


      `}</style>

    </div>

  );
}